<template>
  <main>
    <section>
      <Lesson v-if="lesson" :class="`${editor || output ? 'editor' : ''}`"/>
      <Editor
        v-if="editor"
        :class="`${lesson ? 'lesson' : ''} ${output ? 'output' : ''}`"
      />
      <Output
        v-if="output"
        :class="`${lesson ? 'lesson' : ''} ${editor ? 'editor' : ''}`"
      />
    </section>
    <Navigation />
  </main>
</template>

<style>
main {
  overflow: hidden;
  max-width: 100vw;
  min-width: 100vw;
  max-height: 100vh;
  min-height: 100vh;
} section {
  overflow: auto;
  height: calc(100vh - 50px);
  min-height: calc(100vh - 50px);
  max-height: calc(100vh - 50px);
} #lesson, #editor, #output {
  height: 100%;
  max-height: 100%;
  min-height: 100%;
} #editor.lesson, #output.lesson, #lesson.editor {
  height: 50%;
  max-height: 50%;
  min-height: 50%;
} #editor.lesson.output, #output.lesson.editor {
  width: 50%;
  max-width: 50%;
  min-width: 50%;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';

import store from "@/store";

import Editor from "@/components/Editor.vue";
import Lesson from "@/components/Lesson.vue";
import Output from "@/components/Output.vue";
import Navigation from "@/components/Navigation.vue";

interface App {
  lesson: Boolean,
  editor: Boolean,
  output: Boolean,
}

export default defineComponent({
  components: {
    Editor,
    Lesson,
    Output,
    Navigation,
  },
  data () {
    return {
      lesson: true,
      editor: true,
      output: false,
    } as App;
  },
  mounted () {
    store.dispatch('open', {
      callback: (key: string) => {
        if (key === 'lesson') {
          this.lesson = !this.lesson;
        } else if (key === 'editor') {
          this.editor = !this.editor;
        } else if (key === 'output') {
          this.output = !this.output;
        }
      }
    });
  }
});
</script>


